/**
 * On-screen build badge (ROADMAP #83a).
 *
 * Shows which build is actually running — the release version + short
 * commit SHA, stamped into the bundle at build time (Dockerfile
 * --build-arg → VITE_APP_VERSION / VITE_GIT_SHA → import.meta.env).
 * Pinned at the foot of the sidebar so "is my new code live?" is a
 * glance, not a bundle grep. Title shows the full SHA on hover.
 *
 * Values default to the local-dev sentinels ('dev' / 'unknown') when no
 * build arg was passed (local `npm run dev` / podman-compose).
 */
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export function BuildBadge() {
  // Read at render (not module scope) so tests can stub the env.
  const version = import.meta.env.VITE_APP_VERSION ?? 'dev';
  const sha = import.meta.env.VITE_GIT_SHA ?? 'unknown';
  const shortSha = sha === 'unknown' ? sha : sha.slice(0, 7);

  return (
    <Box sx={{ px: 2, py: 1 }}>
      <Typography
        variant="caption"
        color="text.disabled"
        title={`version ${version} · commit ${sha}`}
        sx={{ display: 'block', fontFamily: 'monospace', lineHeight: 1.3 }}
      >
        {version} · {shortSha}
      </Typography>
    </Box>
  );
}
